import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { fromNow } from '../../../core/date';
import { bidType } from './BookingPropTypes';
import DraftRenderer from '../../../components/DraftRenderer/DraftRenderer';
import NoteFormRich from './NoteFormRich';

function hasValue(values) {
  if (!values) {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(values, 'length')) {
    return values.length !== 0;
  }
  return false;
}
function formatNotes(notes) {
  if (hasValue(notes)) {
    const noteList = [];
    notes.forEach(note => {
      if (Object.keys(note.rich_text).length > 0) {
        noteList.push(
          <div className="note" key={note.id}>
            <DraftRenderer raw={note.rich_text} />
            <p className="text-muted">
              {fromNow(note.created_on)} by {note.author.first_name} {note.author.last_name}
            </p>
          </div>
        );
      } else {
        noteList.push(
          <div className="note" key={note.id}>
            <p>{note.text}</p>
            <p className="text-muted">
              {fromNow(note.created_on)} by {note.author.first_name} {note.author.last_name}
            </p>
          </div>
        );
      }
      if (notes.indexOf(note) < notes.length - 1) {
        noteList.push(<hr />);
      }
    });
    return noteList;
  }
  return null;
}

class BidDetailNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addingNote: false,
    };
    this.saveNote = this.saveNote.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  saveNote(values) {
    this.props.editBid(this.props.bid.id, { note_json: values });
    this.handleClose();
  }
  handleClose() {
    this.setState({ addingNote: false });
  }
  handleOpen() {
    this.setState({ addingNote: true });
  }
  render() {
    const { bid, isNew } = this.props;
    const hasNotes = hasValue(bid.notes);
    const noteList = formatNotes(bid.notes);

    return (
      <div>
        {hasNotes && <h4>Bid Notes</h4>}
        <div className="note-list">{noteList}</div>
        <div>
          {!isNew &&
            !this.state.addingNote && (
              <Button bsStyle={'success'} onClick={this.handleOpen}>
                Add Note
              </Button>
            )}
          {!isNew &&
            this.state.addingNote && (
              <NoteFormRich onSubmit={this.saveNote} handleClose={this.handleClose} />
            )}
        </div>
      </div>
    );
  }
}

BidDetailNotes.propTypes = {
  bid: PropTypes.shape(bidType).isRequired,
  isNew: PropTypes.bool.isRequired,
  editBid: PropTypes.func.isRequired,
};

export default BidDetailNotes;



// WEBPACK FOOTER //
// src/routes/booking/components/BidDetailNotes.js